








































import Vue from "vue";
import { storeService } from "@/common/services/StoreService";
import StoreInfo from "@/stores/pages/StoreInfo.vue";
import { assertNotNull } from "@/common/utils/Utils";
import { Paths, RouteInfoMap } from "@/common/enums/RouterPaths";
import { ElementColors } from "@/common/theme/ElementColors";
import StoreCreator from "@/stores/pages/StoreCreator.vue";
import { AdminStore } from "@/common/models/AdminStore";

export default Vue.extend({
  name: "Stores",
  components: {
    StoreCreator,
    StoreInfo,
  },
  props: {
    storeId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      colors: ElementColors,
      selectedStore: null as AdminStore | null,
      isLoading: false as boolean,
      storeService,
      snackbar: false as boolean,
      snackbarText: "" as string,
    };
  },
  computed: {
    breadcrumbs(): Array<Record<string, string | boolean>> {
      return [
        {
          text: "Home",
          to: "/",
        },
        {
          text: this.selectedStore?.name ?? "",
          disabled: true,
        },
      ];
    },
    currentStore(): string {
      return this.storeService.selectedStore;
    },
  },
  watch: {
    currentStore: function (): void {
      this.setSelectedStore();
    },
  },
  async beforeMount() {
    this.storeService.selectedStore = this.storeId;
    await this.setSelectedStore();
  },
  methods: {
    async setSelectedStore(): Promise<void> {
      storeService.getAdminStoreById(storeService.selectedStore).then(async (result) => {
        if (result) {
          if (this.selectedStore?.id !== result.id) {
            await this.$router
              .push({
                name: RouteInfoMap.get(Paths.Stores)?.name,
                query: {
                  storeId: assertNotNull(result).id.toString(),
                },
              })
              .catch((error) => {
                if (error.name != "NavigationDuplicated") {
                  throw error;
                }
              });
            this.selectedStore = result;
          }
        } else {
          this.selectedStore = null;
        }
      });
    },
    async updateStores(): Promise<void> {
      await this.setSelectedStore();
      this.snackbarText = this.$t("modules.stores.pages.stores.update-success").toString();
      this.snackbar = true;
    },
    storeAdded(): void {
      this.snackbarText = this.$t("modules.stores.pages.stores.add-success").toString();
      this.snackbar = true;
    },
  },
});
